import { createSelector } from '@reduxjs/toolkit';

export const getPromoCodesState = (state) => state.promoCodes;
export const getPromoCodeState = (state) => state.promoCode;

export const getPromoCodes = createSelector(
  getPromoCodesState,
  (promoCodesState) => promoCodesState.data,
);
